<div *ngFor="let msg of globalFieldErrorMsgs" [ngClass]="clazz">
    <span class="error-class">{{msg}}</span>
</div>
